export default {
  documentTitle:
    '하드웨어 지갑 - 암호화 자산을 지켜주는 키의 파트너 | KeyPal',
  product: '제품',
  learn: '학습',
  support: '지원',
  others: '기타',
  language: '언어',
  forBusiness: '비즈니스용',
  apps: '앱',
  secretBox: 'Secret Box',
  learnMore: '자세히 보기', 
  goShoppingCart: '스토어로 이동', 
  contactUs: '문의하기:', 
  tutorials: '튜토리얼', 
  mobileWallet: '모바일 지갑', 
  extensionWallet: '확장 프로그램 지갑', 
  cases: '케이스 스터디:', 
  cooperationSolution: '비즈니스 협력안', 
  information: '정보', 
  security: '안전', 
  darkMode: '다크 모드',
  KeyPal_2_firmware: 'KeyPal 2 펌웨어', 
  KeyPal_Plus_firmware: 'KeyPal Plus 펌웨어', 
  more: '그 외 다수...',
  comingSoon: '곧 출시 예정',
}
